/**
 * MyGemaPro APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthUserDto { 
    id: string;
    userName: string;
    token: string;
    tenantType: AuthUserDto.TenantTypeEnum;
    mustChangePassword: boolean;
}
export namespace AuthUserDto {
    export type TenantTypeEnum = 'Internal' | 'External' | 'Contractor';
    export const TenantTypeEnum = {
        Internal: 'Internal' as TenantTypeEnum,
        External: 'External' as TenantTypeEnum,
        Contractor: 'Contractor' as TenantTypeEnum
    };
}


